export default __webpack_public_path__ + "static/media/5_4.83494835.png";